import React from 'react';
import { CheckoutWithEth } from '@paperxyz/react-client-sdk-checkout-with-eth';
import { theme } from '@components-shared/src/stitches';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { ModalContext, ModalType } from '@context/modal';
import type { BuyEditionSongDetailsFragmentDoc, FragmentType } from '@graphql/reactQuery';
import { type LegacySigner } from '@hooks/useLegacyEthers';
import type { PlaylistReferral } from '@utils/types';
import { PaperProcessingModal } from '../../../PaperProcessingModal';
import { SongDetails } from '../CreditCardCheckoutSongDetails';

export const PaperEthMintModal = ({
  paperKey,
  signer,
  data,
  chainId,
  releaseId,
  onSuccessfulTransaction,
  selectedTier,
  playlistReferral,
}: {
  paperKey: string;
  releaseId: string;
  signer: LegacySigner;
  chainId: number;
  data: FragmentType<BuyEditionSongDetailsFragmentDoc>;
  onSuccessfulTransaction: () => void;
  selectedTier: number | null;
  playlistReferral: PlaylistReferral | null;
}) => {
  const { closeCancelModal } = ModalContext.useContainer();
  const { openModal } = ModalContext.useContainer();

  return (
    <StandardModal
      bodyWithoutPaddingBottom
      body={
        <>
          <SongDetails data={data} selectedTier={selectedTier} />
          <div
            className="[&>div]:h-[250px]"
            onScroll={e => {
              e?.preventDefault();
              e?.stopPropagation();
            }}
            onTouchMove={e => {
              e?.preventDefault();
              e?.stopPropagation();
            }}
          >
            <CheckoutWithEth
              sdkClientSecret={paperKey}
              showConnectWalletOptions={false}
              payingWalletSigner={signer}
              onSuccess={async result => {
                onSuccessfulTransaction();
                openModal(ModalType.PAPER_PROCESSING, {
                  body: (
                    <PaperProcessingModal
                      receiptId={result.transactionId}
                      releaseId={releaseId}
                      chainId={chainId}
                      playlistReferral={playlistReferral}
                    />
                  ),
                });
              }}
              options={{
                colorBackground: theme.colors.white.value,
                colorPrimary: theme.colors.black.value,
                colorText: theme.colors.base800.value,
                borderRadius: 6,
              }}
            />
          </div>
        </>
      }
      title="Pay with ETH on Mainnet"
      closeModal={closeCancelModal}
    />
  );
};
